<template>
  <div class="header-scope">
    <div class="header">
      <img @click="$router.push(iPath('/'))" src="~@/common/image/logo.png" class="logo">
      <div class="right-box">
        <div class="lang-dropdown">
          <div class="curr">
            <span class="world"></span>
            {{ cnLang }}
            <span class="arrow"></span>
          </div>
          <ul class="lang">
            <li>
              <router-link :to="$route.fullPath.replace(/^\/[^\/]+/, '')">English</router-link>
            </li>
            <li>
              <router-link :to="locale === 'zh-CN' ? $route.fullPath : '/zh-CN' + sourcePath">简体中文</router-link>
            </li>
            <li>
              <router-link :to="locale === 'zh-TW' ? $route.fullPath : '/zh-TW' + sourcePath">繁体中文</router-link>
            </li>
            <li>
              <router-link :to="locale === 'it' ? $route.fullPath : '/it' + sourcePath">Italian</router-link>
            </li>
            <li>
              <router-link :to="locale === 'id' ? $route.fullPath : '/id' + sourcePath">Indonesia</router-link>
            </li>
          </ul>
        </div>
        <div v-if="token" class="avatar">
          <div
            class="img"
            :style="{ backgroundImage: `url('${userInfo ? userInfo.avatar_url : ''}')` }"
          ></div>
          <ul class="setting">
            <li @click="logout">{{$t('logout')}}</li>
          </ul>
        </div>
        <router-link v-else :to="iPath('/login')" class="login-btn">{{$t('login')}}</router-link>
        <router-link v-if="canEnter" :to="iPath('/dashboard')" class="enter">{{$t('enter')}}</router-link>
        <router-link v-else :to="iPath('/openClass')" class="enter">{{$t('open')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import langMap from '@/common/json/lang.json'
import { get } from '@/utils/ajax'
export default {
  inject: ['iPath'],
  computed: {
    ...mapState(['locale', 'token', 'userInfo']),
    cnLang() {
      return langMap[this.locale]
    },
    canEnter() {
      return this.token && this.userInfo && this.userInfo.registered
    },
    sourcePath() {
      const reg = /^(\/(zh-CN|zh-TW|it|id))/
      return this.$route.fullPath.replace(reg, '')
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      const store = this.$store
      if (store.state.token) {
        store.dispatch('getUserInfo')
      }
    },
    async logout() {
      await get(`/edu/zone/exit`)
      this.$store.commit('LOGOUT')
    }
  }
}
</script>
<style lang="scss">
.header-scope {
  background-color: white;
  border-bottom: 1px solid #00c4aa;
  .header {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
  }
  .lang-dropdown {
    position: relative;
    color: #333;
    margin-right: 20px;
    margin-top: 30px;
    &:hover .lang {
      display: block;
    }
    .curr {
      display: flex;
      padding-bottom: 33px;
      align-items: center;
      cursor: pointer;
    }
    .world {
      margin-right: 5px;
      width: 16px;
      height: 16px;
      display: block;
      background-image: url('~@/common/image/icon_world.png');
    }
    li {
      text-align: center;
      margin-top: 7px;
      margin-bottom: 7px;
      a {
        color: #333;
      }
      a:hover {
        color: #00c4aa;
      }
    }
    .arrow {
      transform: rotate(180deg);
      margin-left: 5px;
      width: 12px;
      height: 7px;
      display: block;
      background-image: url('~@/common/image/icon_arrow.png');
    }
    .lang {
      display: none;
      position: absolute;
      width: 120%;
      top: 50px;
      left: 0;
      z-index: 20;
      background-color: white;
    }
    .router-link-exact-active {
      color: #00c4aa;
    }
  }

  .right-box {
    display: flex;
    align-items: center;
  }
  .logo {
    width: 150px;
    cursor: pointer;
  }
  .login-btn {
    font-size: 14px;
    color: #00c4aa;
    border: 1px solid #00c4aa;
    padding: 6px 10px;
    border-radius: 4px;
    &:hover {
      color: white;
      background-color: #00c4aa;
    }
  }
  .avatar {
    cursor: pointer;
    position: relative;
    margin-top: 25px;
    padding-bottom: 25px;
    &:hover .setting {
      display: block;
    }
    .img {
      background-size: cover;
      background-position: center;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      border: 1px solid #666;
    }
    .setting {
      display: none;
      position: absolute;
      width: 100px;
      top: 58px;
      left: -30px;
      z-index: 20;
      background-color: white;
    }
    li {
      text-align: center;
      margin-top: 7px;
      margin-bottom: 7px;
      color: #333;
      &:hover {
        color: #00c4aa;
      }
    }
  }
  .avatar,
  .login-btn {
    margin-right: 20px;
  }
  .enter {
    font-size: 14px;
    border-radius: 4px;
    color: white;
    background-color: #00c4aa;
    padding: 6px 10px;
  }
}
</style>
<i18n lang="yaml">
en:
  open: Open Future Classroom
  enter: Enter Future Classroom
  login: Log In
  logout: Log out
zh-CN:
  open: 开通未来教室
  enter: 进入未来教室
  login: 登录
  logout: 退出
zh-TW:
  open: 開通未來教室
  enter: 進入未來教室
  login: 登錄
  logout: 退出
it:
  open: Iscriviti a Future Classroom
  enter: Entra Future Classroom
  login: Accedi
  logout: Esci
id:
  open: Buka Kelas Masa Depan
  enter: Masuk Kelas Masa Depan
  login: Masuk
  logout: Keluar
</i18n>
